import React, { useState } from "react";
import {
  Table,
  Space,
  Drawer,
  Form,
  Input,
  Button,
  Modal,
  Spin,
  message,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  list_upload_document_actionHandler,
  edit_upload_document_actionHandler,
  delete_upload_document_actionHandler,
} from "../../../../../Redux/Actions/user/CreateUploadDocument";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../ResourceStyle.css";

const EditDoc = () => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isDeleteDrawerVisible, setIsDeleteDrawerVisible] = useState(null);

  const dispatch = useDispatch();
  const DataOfTable = useSelector(
    (state) =>
      state.list_upload_documents_data?.list_upload_documents_data?.data
  );

  const listLoader = useSelector((state) => state.list_upload_documents_data);
  const deleteLoader = useSelector(
    (state) => state.delete_upload_documents_data
  );
  const updateLoader = useSelector((state) => state.edit_upload_documents_data);

  useEffect(() => {
    dispatch(list_upload_document_actionHandler());
  }, [dispatch]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Document Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space size="middle">
          <a onClick={() => handleEdit(record)}>Edit</a>
          <a type="danger" onClick={() => handleDelete(record)}>
            Delete
          </a>
        </Space>
      ),
    },
  ];

  const handleEdit = (record) => {
    setSelected(record);
    setDrawerVisible(true);
  };

  const handleNameChange = (e) => {
    setSelected((prevData) => ({
      ...prevData,
      name: e.target.value,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const fileType = file.type.split("/")[1];

      setSelected((prevData) => ({
        ...prevData,
        fileType: fileType,
        file: file,
      }));
    }
  };

  // const handleFileChange=(event)=>{

  //   // setSelected((prevData)=>({
  //   //   ...prevData,
  //   //   file_path:e.target.value
  //   // }))
  // }
  const handleDelete = (record) => {
    setSelected(record);

    setIsDeleteDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
  };
  const handleSubDeleteCancel = () => {
    setIsDeleteDrawerVisible(false);
  };
  const handleDeleteConfirm = () => {
    if (selected) {
      dispatch(delete_upload_document_actionHandler(selected.id));
      if (deleteLoader.error) {
        message.error("Something went wrong");
      } else {
        message.success("Document deleted successfully");
      }
    }
    setIsDeleteDrawerVisible(false);
  };
  const updateDocument = () => {
    if (selected) {
      const formData = new FormData();
      formData.append("id", selected.id);
      formData.append("name", selected.name);
      formData.append("file", selected.file);
      dispatch(edit_upload_document_actionHandler(formData));
      handleDrawerClose();
      if (updateLoader.error) {
        message.error("Something went wrong");
      } else {
        message.success("DOcument Updated Successfully ");
      }
    }
  };

  return (
    <div>
      {listLoader.loader && (
        <div className="spinner">
          {" "}
          <Spin />
        </div>
      )}
      {deleteLoader.loader && (
        <div className="spinner">
          {" "}
          <Spin />
        </div>
      )}
      {updateLoader.loader && (
        <div className="spinner">
          {" "}
          <Spin />
        </div>
      )}
      <Table
        dataSource={DataOfTable}
        columns={columns}
        pagination={{ pageSize: 10 }}
      />

      <Drawer
        title="Edit Document"
        placement="right"
        closable={true}
        onClose={handleDrawerClose}
        visible={isDrawerVisible}
        width={500}
      >
        <Form>
          <div className="new-btn">
            <h2>Edit Documents</h2>
            <Button
              className="close-btn"
              type="text"
              placement="right"
              shape="circle"
              icon={<CloseOutlined />}
              size="large"
              onClick={handleDrawerClose}
            />
          </div>
          <div className="video-input-field">
            <label>Name</label>
            <Input
              onChange={handleNameChange}
              value={selected?.name}
              placeholder="Sample"
            />
          </div>

          <div className="video-input-field2">
            <label>File</label>
            <input
              type="file"
              onChange={handleFileChange}
              accept=".pdf, .mp4, .jpeg, .png, .mov, .mvi" 
            />
            {/* <Input
              onChange={handleFileChange}
                placeholder="Sample"
                value={selected?.type}
              /> */}
          </div>
          <div className="upload">
            <button onClick={updateDocument} className="upload-button">
              Save Changes
            </button>
          </div>
        </Form>
      </Drawer>

      <Modal
        title="Confirm Delete"
        visible={isDeleteDrawerVisible}
        onCancel={handleSubDeleteCancel}
        onOk={handleDeleteConfirm}
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{
          style: { backgroundColor: "red", borderColor: "#ff4d4f" },
        }}
      >
        <p>Are you sure you want to delete this item?</p>
      </Modal>
    </div>
  );
};

export default EditDoc;
